import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationCancel, NavigationEnd } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { filter } from 'rxjs/operators';
import { FcmService } from './components/services/FCM/fcm.service';
declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent implements OnInit {
    location: any;
    routerSubscription: any;

    constructor(private router: Router,private fcm: FcmService) {
    }
    fcmtoken: string;
    ngOnInit(){
        this.recallJsFuntions();
        const fcm_token = localStorage.getItem('FCM_Token');
        if (!fcm_token) {
            this.fcm.generateRandomFCMToken();
        }else{
            this.fcmtoken = localStorage.getItem('FCM_Token');
        }
        const token = localStorage.getItem('fontana_token');
        if(!token){
            sessionStorage.setItem('guestMode', 'true');
        }else{
            sessionStorage.removeItem('guestMode');
        }
        // this.fcmtoken = localStorage.getItem('FCM_Token');
        // console.log(this.fcmtoken)
    }

    recallJsFuntions() {
        this.router.events
        .subscribe((event) => {
            if ( event instanceof NavigationStart ) {
                $('.preloader').fadeIn('slow');
            }
        });
        this.routerSubscription = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
        .subscribe(event => {
            $.getScript('../assets/js/custom.js');
            $('.preloader').fadeOut('slow');
            this.location = this.router.url;
            if (!(event instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }
}